import { Injectable } from '@angular/core';
import { ApplicationCaseAdvancedFilterOptions, BaseFilterOptions } from 'rome-library';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CaseFilterStore {
  private _enable: boolean;
  private _showAlertedCases: boolean;
  public caseHubReloaded$ = new BehaviorSubject<any>(false);

  public get enable(): boolean {
    return this._storedFilter && this._enable;
  }
  public set enable(value: boolean) {
    this._enable = value;
  }

  private _storedFilter: BaseFilterOptions<ApplicationCaseAdvancedFilterOptions>;
  public get cachedCaseFilter(): BaseFilterOptions<ApplicationCaseAdvancedFilterOptions> {
    return (this._enable = undefined) || this._storedFilter;
  }
  public set cachedCaseFilter(value: BaseFilterOptions<ApplicationCaseAdvancedFilterOptions>) {
    this._storedFilter = JSON.parse(JSON.stringify(value));
  }

  public clearCachedCaseFilter(): void {
    this._storedFilter = undefined;
  }

  public get showAlertedCases(): boolean {
    return this._showAlertedCases && !(this._showAlertedCases = false);
  }
  public set showAlertedCases(value: boolean) {
    this._showAlertedCases = value;
  }

  public notifyOnCaseHubReload(): void {
    this.caseHubReloaded$.next(true);
  }
}
